/* eslint consistent-return: 0 */
/* eslint no-param-reassign: 0 */
/* eslint no-unused-vars: 0 */
/* eslint-disable */

import {
  AREAS_CONSULTA,
  EMAILS_ASOCIADOS,
  CONTRATACIONES_MOTIVOS,
  AUTORIZACIONES_MOTIVOS,
  LIQUIDACIONES_MOTIVOS,
  CONTRATACIONES_AMBITO,
  FETCH_INBOX,
  LOAD_INBOX,
  LOAD_TABLE,
  SET_ACTIVE_TAB,
  LOAD_DETALLE_TRAMITE,
  SET_ARCHIVOS_ETAPAS,
  SET_TRAMITE_RESPONDER,
  REMOVE_TRAMITE_FROM_PENDIENTES,
  SELECT_TRAMITE_AUTORIZACION,
  SELECT_AFILIADO_AUTORIZACION,
  CAPWEB_AUTORIZACIONES_TIEMPO_MAX,
  SET_TRAMITE_SELECCIONADO_CAP,
  RESET_CAP_WEB_STATE,
} from '../../constants/index';
import { responseWait, responseEnd } from '../common/loadingActions';
import { showMessage } from '../common/messagesActions';
import { logoutUser } from '../users/logoutUser';
import { apiManagerRequest } from '../../axios';
import {
  validarAfiliadoSucess,
  validarAfiliadoError,
  validarAfiliado,
} from '../tramitesOnline/autorizaciones/altaAutorizacionesActions';
import { ADP_SERVICES } from '../../constants/capweb';
import Session from '../../utils/session';
import { baseApiManagerUrl, urlUsuariosByCodeCap } from '../urls';
import Dates from '../../utils/dates';
import { optionProcess } from '../../constants/sgi';

let env = window.REACT_APP_ENV;
if (env === 'prod') env = '';

export const unidadesDeGestion = () => async (dispatch) => {
  dispatch(responseWait());
  let token;
  let codigoPrestador;
  const auth = Session.getAuth();
  if (auth) {
    token = Session.getAuthenticationToken();
    codigoPrestador = auth?.modelEspecifico?.codPrestador;
    //const env = await getEnv()

    // Ambitos y esOdonto
    Promise.all([
      fetch(
        `https://mobile${env}.swissmedical.com.ar/api-smg/V1/prestadores/cap/${codigoPrestador}/unidades-gestion`,
        {
          headers: {
            'authorization': 'Bearer ' + token,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
        },
      ),
      fetch(
        `https://mobile${env}.swissmedical.com.ar/api-smg/V1/prestadores/cap/${codigoPrestador}/Odontologia`,
        {
          headers: {
            'authorization': 'Bearer ' + token,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
        },
      ),
    ])
      .then(function (responses) {
        return Promise.all(
          responses.map(function (response) {
            return response.json();
          }),
        );
      })
      .then(function (data) {
        let ambito = 'A';
        let unidadesDeGestion = [];

        if (data[0]) {
          const ambitoResponse = data[0];
          ambito = 'A';
          ambitoResponse.forEach((unidades) => unidadesDeGestion.push(unidades.unidadGestion));
          // para simular:
          // unidadesDeGestion = [ 6 ]
          // Solo 6
          if (unidadesDeGestion.length === 1 && unidadesDeGestion.includes(6)) ambito = 'I';
          // Si vienen varias unidades de gestión, es interior cuando trae 6 y cualquier otra distinta de 5.
          if (
            unidadesDeGestion.length > 1 &&
            unidadesDeGestion.includes(6) &&
            !unidadesDeGestion.includes(5)
          )
            ambito = 'I';
        }

        dispatch({
          type: CONTRATACIONES_AMBITO,
          ambito,
        });

        // AREAS DE CONSULTA
        fetch(
          `https://mobile${env}.swissmedical.com.ar/api-smg/V1/prestadores/cap/${ambito}/areas-consulta`,
          {
            headers: {
              'authorization': 'Bearer ' + token,
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
          },
        )
          .then((response) => {
            if (response) {
              return response.json();
            } else {
              reject();
            }
          })
          .then((json) => {
            dispatch(responseEnd());
            dispatch({
              type: AREAS_CONSULTA,
              areasDeConsulta: json.concat(
                ADP_SERVICES.filter((x) => !x.tipos || x.tipos.includes(auth.tipoPrestador.id)),
              ),
            });
          })
          .catch((err) => {
            dispatch(responseEnd());
            dispatch({
              type: AREAS_CONSULTA,
              areasDeConsulta: [],
            });
          });

        let esOdonto;
        if (data[1] && data[1][0]) {
          esOdonto = data[1][0].esOdonto;
          let odontoURL = esOdonto === 'S' ? auth.tipoPrestador.id : '-';
          let ambitoURL = ambito === 'A' ? '2' : '17';
          // LISTA DE MOTIVOS
          const url = `https://mobile${env}.swissmedical.com.ar/api-smg/V1/prestadores/cap/${ambitoURL}/${auth.tipoPrestador.id}/${odontoURL}/motivos`;
          fetch(
            `https://mobile${env}.swissmedical.com.ar/api-smg/V1/prestadores/cap/${ambitoURL}/${auth.tipoPrestador.id}/${odontoURL}/motivos`,
            {
              headers: {
                'authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
              },
            },
          )
            .then((response) => {
              if (response) {
                return response.json();
              } else {
                reject();
              }
            })
            .then((json) => {
              dispatch(responseEnd());
              dispatch({
                type: CONTRATACIONES_MOTIVOS,
                contratacionesMotivos: json,
              });
            })
            .catch((err) => {
              dispatch(responseEnd());
              dispatch({
                type: CONTRATACIONES_MOTIVOS,
                contratacionesMotivos: [],
              });
            });
        }
      })
      .catch(function (error) {
        // if there's an error, log it
        //console.err(error);
      });

    try {
      const { status, data } = await apiManagerRequest.get(
        `${baseApiManagerUrl}/v1/motivos-web/autorizaciones`,
      );

      if (status === 200) {
        dispatch({
          type: AUTORIZACIONES_MOTIVOS,
          autorizacionesMotivos: data,
        });
      }

      if (status === 401) {
        dispatch(logoutUser());
      }
    } catch (error) {
      dispatch({
        type: AUTORIZACIONES_MOTIVOS,
        autorizacionesMotivos: [],
      });
    }

    try {
      const { status, data } = await apiManagerRequest.get(
        `${baseApiManagerUrl}/v1/motivos-web/liquidaciones`,
      );

      if (status === 200) {
        dispatch({
          type: LIQUIDACIONES_MOTIVOS,
          liquidacionesMotivos: data,
        });
      }

      if (status === 401) {
        dispatch(logoutUser());
      }
    } catch (error) {
      dispatch({
        type: LIQUIDACIONES_MOTIVOS,
        liquidacionesMotivos: [],
      });
    }
  }
};

export const listarTramites = (data) => async (dispatch) => {
  dispatch(responseWait());
  const auth = Session.getAuth()?.modelEspecifico;
  let token = Session.getAuthenticationToken();
  let codigoPrestador;
  if (auth) {
    codigoPrestador = auth?.codPrestador;

    if (data.fecha === undefined || (!data.fecha.startDate && !data.fecha.endDate)) {
      data.fecha = {
        startDate: Dates.getWithSubtractDays(15).toDate(),
        endDate: new Date(),
      };
    } else if (data.fecha.startDate && !data.fecha.endDate) {
      data.fecha = {
        startDate: Dates.get(data.fecha.startDate).toDate(),
        endDate: new Date(),
      };
    }
    let motivo = null;
    if (data.area) {
      if (data.area === 2) {
        motivo = data.ambitoPrestador === 'I' ? 17 : 2;
      } else {
        motivo = data.area;
      }
    }
    const json = {
      motivoId: motivo,
      ambitoPrestador: data.ambitoPrestador,
      prestad: codigoPrestador,
      estado: data.estado ? parseInt(data.estado) : '',
      fechaDesde: data.fecha.startDate
        ? Dates.get(data.fecha.startDate).toFormat('YYYY/MM/DD')
        : null,
      fechaHasta: data.fecha.endDate
        ? Dates.getWithAddDays(1, data.fecha.endDate).toFormat('YYYY/MM/DD')
        : null,
    };
    return new Promise((resolve, reject) => {
      fetch(
        `https://mobile${env}.swissmedical.com.ar/api-smg/V3/prestadores/cap/ConsultaTramites`,
        {
          method: 'POST',
          headers: {
            'authorization': 'Bearer ' + token,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify(json),
        },
      )
        .then((response) => {
          if (response) {
            return response.json();
          } else {
            reject();
          }
        })
        .then((json) => {
          dispatch(responseEnd());
          let ordenado = json.sort((a, b) => (a.inicio < b.inicio ? 1 : -1));
          if (motivo === 'DPP' || motivo === 'DOC' || motivo === 'DDA') {
            ordenado = ordenado.map((x) => {
              switch (motivo) {
                case 'DPP':
                  x.detalleMotivo = 'Actualización Datos Personales y Profesionales';
                  break;
                case 'DOC':
                  x.detalleMotivo = 'Documentación';
                  break;
                case 'DDA':
                  x.detalleMotivo = 'Domicilio de Atención';
                  break;
              }
              //x.detalleMotivo = "ADP";
              x.motivoWebDetalle = x.areaConsulta;
              //x.motivoWebDetalle = "ADP"
              x.nroTramite = x.tramiteJbpm;
              x.inicio = x.altaFecha;
              x.respuestaFecha = x.fechaUltimoContacto;
              x.estadoDesc = x.estado;
              return x;
            });
          }
          if (motivo === 'DOC') {
            ordenado = ordenado.map((x) => {
              x.motivoWebDetalle = x.areaConsulta;
              x.nroTramite = x.tramiteJbpm;
              x.inicio = x.altaFecha;
              x.respuestaFecha = x.fechaUltimoContacto;
              x.estadoDesc = x.estado;
              return x;
            });
          }
          resolve(ordenado.filter((r) => r.estadoDesc));
        })
        .catch((err) => {
          dispatch(responseEnd());
          resolve([]);
        });
    });
  } else {
    dispatch(logoutUser());
  }
};

export const listarMails = () => async (dispatch) => {
  const auth = Session.getAuth()?.modelEspecifico;
  let token = Session.getAuthenticationToken();
  let codigoPrestador;
  if (auth) {
    codigoPrestador = auth?.codPrestador;
    dispatch(responseWait());

    if (env === 'prod') env = '';
    return new Promise((resolve, reject) => {
      fetch(urlUsuariosByCodeCap.replace(':code', codigoPrestador), {
        headers: {
          authorization: 'Bearer ' + token,
        },
      })
        .then((response) => {
          if (response) {
            return response.json();
          } else {
            reject();
          }
        })
        .then((json) => {
          dispatch(responseEnd());
          dispatch({
            type: EMAILS_ASOCIADOS,
            emails: json,
          });
        })
        .catch((err) => {
          dispatch(responseEnd());
          resolve(err);
        });
    });
  } else {
  }
};

export const detalleTramite = (nroTramite) => async (dispatch) => {
  const auth = Session.getAuth()?.modelEspecifico;
  let token = Session.getAuthenticationToken();

  if (auth) {
    let codigoPrestador = auth?.codPrestador;
    if (env === 'prod') env = '';
    return new Promise((resolve, reject) => {
      fetch(
        `https://mobile${env}.swissmedical.com.ar/api-smg/V2/prestadores/cap/${nroTramite}/DetalleTramite`,
        {
          headers: {
            'authorization': 'Bearer ' + token,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
        },
      )
        .then((response) => {
          if (response) {
            return response.json();
          } else {
            reject();
          }
        })
        .then((json) => {
          if (json && json[0]) {
            Promise.all([
              fetch(
                `https://mobile${env}.swissmedical.com.ar/api-smg/V1/prestadores/cap/WCAP/${json[0].workflow_id}/files`,
                {
                  headers: {
                    'authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                  },
                },
              ),
              fetch(
                `https://mobile${env}.swissmedical.com.ar/api-smg/V1/prestadores/cap/SCAP/${json[0].workflow_id}/files`,
                {
                  headers: {
                    'authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                  },
                },
              ),
            ])
              .then(function (responses) {
                return Promise.all(
                  responses.map(function (response) {
                    return response.json();
                  }),
                );
              })
              .then(function (jsonArchivos) {
                dispatch(responseEnd());
                const detalle = json;
                const cantMovimientos = detalle.length - 1;
                if (detalle[0])
                  detalle[0].archivosDetalle =
                    (jsonArchivos[0] && jsonArchivos[0].imagenesArchivo) || [];
                if (detalle[cantMovimientos])
                  detalle[cantMovimientos].archivosRespuesta =
                    (jsonArchivos[1] && jsonArchivos[1].imagenesArchivo) || [];

                dispatch(responseEnd());
                /*dispatch({
                type: DETALLE_TRAMITES_CAP,
                detalleTramite: {
                  nroTramite,
                  detalle
                }
              });  */
                resolve(detalle);
              })
              .catch((err) => {
                dispatch(responseEnd());
                resolve(err);
              });
          } else {
            if (json && json.tramite && json.tramite.rudiPrestador) {
              const { nroTramite, tipoTramite } = json.tramite.rudiPrestador;
              fetch(
                `https://mobile${env}.swissmedical.com.ar/api-smg/v0/archivos/${tipoTramite}/${nroTramite}`,
                {
                  headers: {
                    'authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                  },
                },
              )
                .then((files) => {
                  return files.json();
                })
                .then((files) => {
                  dispatch(responseEnd());
                  json.tramite.archivos = files.imagenesArchivo;
                  resolve(json);
                  return json;
                })
                .catch((error) => {
                  dispatch(responseEnd());
                  json.tramite.archivos = [];
                  resolve(json);
                });
            } else {
              dispatch(responseEnd());
              resolve(json);
            }
          }
        })
        .catch((err) => {
          dispatch(responseEnd());
          resolve(err);
        });
    });
    /*
    return {
      area: 'Autorizaciones',
      nTramite: '3',
      inicio: new Date(),
      fechaRespuesta: new Date(),
      respuesta: 'La respuesta, die antwood, the answer',
      estado: 'En proceso',
      nAutorizacion: '2131231',
      nTramiteAutorizacion: '57393023',
      prepaga: '800006',
      contra: '323123123',
      inte: '01',
      nombre: 'elnombre',
      apellido: 'elAapellido',
      motivo: 'motivon',
      comentarios: 'los comentairos en referencia.. al comentario',
      referencia: '434345',
    }*/
  }
};

export const grabarTramite = (data) => async (dispatch) => {
  dispatch(responseWait());
  const auth = Session.getAuth()?.modelEspecifico;
  const razonSocial = Session.getAuth()?.apeRazonSocial;
  const domicilio = Session.getAuth()?.domicilio;
  const authPrestadorTipo = Session.getAuth()?.tipoPrestador?.id;
  let token = Session.getAuthenticationToken();

  let codigoPrestador;
  if (auth) {
    codigoPrestador = auth?.codPrestador;
    // let { env } = await fetch(generateAbsoluteUrl() + '/env').then(res => res.json());
    if (env === 'prod') env = '';

    // ARCHIVOS ADJUNTOS
    const archivos = [];
    if (data.archivos && Array.isArray(data.archivos)) {
      data.archivos.forEach((archivo) => {
        archivos.push({
          fileName: `${archivo.name}.${archivo.extension}`,
          base64Content: archivo.base64,
          sizeInBytes: archivo.size ? archivo.size.toString() : '',
        });
      });
    }

    const detallePedido =
      data.ambito === 'I'
        ? 'Pedido Cap Contrataciones Interior'
        : 'Pedido Cap Contrataciones AMBA y BsAs';
    const workContext =
      data.ambito === 'I' ? 'AMB_CAP_CONTRATACIONES_INTERIOR' : 'AMB_CAP_CONTRATACIONES_AMBA_BSAS';
    const { emailsSeleccionados } = data;

    if (!emailsSeleccionados || emailsSeleccionados.length === 0) {
      // Agrego el email del prestador logueado si no selecciono ninguno
      emailsSeleccionados.push(data.prestadorLogueado);
    }
    const jsonCapWeb = {
      process: {
        variables: {
          workContext: workContext,
          finalizado: 'false',
          processInfo: {
            id: '0',
            name: 'Pedido Cap',
            description: 'Pedido Cap',
            registradoUsuario: optionProcess.user, //"ext_dibarbon",
            registradoNombre: optionProcess.description, //"CN=Diego Barbonetti,OU=Externos,OU=Groups&Users,OU=-SMG-,DC=swm,DC=com,DC=ar,
            credencial: auth && auth.codPrestador ? auth.codPrestador.toString() : '',
            procesoRelacionadoId: data.nroPedidoReplicar ? data.nroPedidoReplicar.toString() : null, //En este campo debe ir el processId cuando se utilice la funcion de duplicar tramites para que en SGI queden como relacionados un tramite respecto al otro
            atencionRelacionadaId: null,
            detalle: `${data.motivoDetalle}, ${
              domicilio && domicilio.provincia ? domicilio.provincia.descripcion : ''
            }, ${domicilio && domicilio.localidad ? domicilio.localidad.descripcion : ''}, ${
              razonSocial || ''
            }, Trámite Generado desde la Web`,
          },
        },
        credencial: auth && auth.codPrestador ? auth.codPrestador.toString() : '',
        version: '1',
        processName: 'Pedido Cap',
        status: 'Running',
        workContext: workContext,
        currentNodeName: '',
        ambitoGestion: '', // "AMB_CLINICA_PROPIA_ODONTO",
        detalle: `${data.motivoDetalle}, ${
          domicilio && domicilio.provincia ? domicilio.provincia.descripcion : ''
        }, ${domicilio && domicilio.localidad ? domicilio.localidad.descripcion : ''}, ${
          razonSocial || ''
        }, Trámite Generado desde la Web`,
        id: null,
        processId: null,
        key: null,
        start: Date.now(),
      },
      capObject: {
        generico: {
          prestadorId: auth && auth.codPrestador ? auth.codPrestador.toString() : '',
          prestadorTipo: authPrestadorTipo,
          motivo: {
            id: 3,
          },
          etapa: {
            sucursalUsuarioId: 1, // 202,
            estado: {
              id: 1,
            },
            id: null,
          },
          estado: {
            id: 1,
            descripcion: 'Pendiente',
          },
          sucursalId: 1, // 202,
          submotivo: {
            id: data.ambito === 'I' ? 17 : 2,
          },
          unidadNegocio: {
            id: 1,
          },
          observacion: '-',
          tomadoPor: null,
          ucid: null,
          ani: null,
          dnis: null,
          registroUsuario: optionProcess.user, // auth.razonSocialPrestador,
          direccion: null,
          detalle: `${data.motivoDetalle}, ${
            domicilio && domicilio.provincia ? domicilio.provincia.descripcion : ''
          }, ${domicilio && domicilio.localidad ? domicilio.localidad.descripcion : ''}, ${
            razonSocial || ''
          }, Trámite Generado desde la Web`,
          submotivoBOAP: {
            id: -1,
          },
        },
        especifico: {
          motivoContacto: {
            id: null, // -1 o null ... 160
          },
          pedido: data.pedido,
        },
        extendedProcess: {
          motivoWeb: parseInt(data.motivo),
          estadoWeb: 1, //1 = Pendiente, 2 = Cerrado
          usuarioWeb: data.prestadorLogueado.email,
          pedidoWeb: data.pedido,
          rudiFiles: archivos,
          emails: emailsSeleccionados,
          mailRedireccion: 0,
          mailFinalizacion: 0,
          info1: data.motivoDetalle,
        },
      },
      id: '3', //Siempre en 3 porque es pedido
      idSubmotive: data.ambito === 'I' ? '17' : '2', //Esto va a variar entre contrataciones amba = 2 y contrataciones interior = 17, en este ejemplo va un 2
      motive: detallePedido, //Idem anterior
      workflowId: null,
    };

    return new Promise((resolve, reject) => {
      fetch(`https://mobile${env}.swissmedical.com.ar/api-smg/V1/prestadores/cap/grabar-tramite`, {
        method: 'POST',
        headers: {
          'authorization': 'Bearer ' + token,
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(jsonCapWeb),
      })
        .then((response) => {
          if (response) {
            return response.json();
          } else {
            reject();
          }
        })
        .then((json) => {
          dispatch(responseEnd());

          resolve(json);

          fetch(
            `https://mobile${env}.swissmedical.com.ar/api-smg/V1/prestadores/cap/${
              json.jbpmProcess
            }/${Date.now()}/PostProcess1`,
            {
              method: 'GET',
              headers: {
                'authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
              },
            },
          )
            .then((response) => {
              if (response) {
                return response.json();
              } else {
                reject();
              }
            })
            .then((json2) => {
              dispatch(responseEnd());

              let idPostProcess = json2 && json2[0] ? json2[0].id : '';
              if (idPostProcess !== '') {
                fetch(
                  `https://mobile${env}.swissmedical.com.ar/api-smg/V1/prestadores/cap/${idPostProcess}/${workContext}/PostProcess2`,
                  {
                    method: 'GET',
                    headers: {
                      'authorization': 'Bearer ' + token,
                      'Content-Type': 'application/json',
                      'Accept': 'application/json',
                    },
                  },
                )
                  .then((response) => {
                    if (response) {
                      return response.json();
                    } else {
                      reject();
                    }
                  })
                  .then((json3) => {
                    dispatch(responseEnd());
                    // resolve(json3)
                  })
                  .catch((err) => {
                    dispatch(responseEnd());
                    resolve(err);
                  });
              }
            })
            .catch((err) => {
              dispatch(responseEnd());
              resolve(err);
            });
        })
        .catch((err) => {
          dispatch(responseEnd());
          resolve(err);
        });
    });
  } else {
    dispatch(logoutUser());
  }
};

export const setTramiteSeleccionado = (tramiteSeleccionado) => (dispatch) => {
  return dispatch({ type: SET_TRAMITE_SELECCIONADO_CAP, payload: tramiteSeleccionado });
};

export const grabarTramiteLiquidaciones = (data) => async (dispatch) => {
  dispatch(responseWait());
  const auth = Session.getAuth()?.modelEspecifico;
  const domicilio = Session.getAuth()?.domicilio;
  const razonSocial = Session.getAuth()?.apeRazonSocial;
  const authPrestadorTipo = Session.getAuth()?.tipoPrestador?.id;

  let token = Session.getAuthenticationToken();
  let codigoPrestador;
  if (auth) {
    codigoPrestador = auth?.codPrestador;
    if (env === 'prod') env = '';

    // ARCHIVOS ADJUNTOS
    const archivos = [];
    if (data.archivos && Array.isArray(data.archivos)) {
      data.archivos.forEach((archivo) => {
        archivos.push({
          fileName: `${archivo.name}.${archivo.extension}`,
          base64Content: archivo.base64,
          sizeInBytes: archivo.size ? archivo.size.toString() : '',
        });
      });
    }

    const workContext = 'AMB_CAP_LIQUIDACIONES';

    const detallePedido = 'Pedido Cap Liquidaciones';
    /* const workContext =
      data.ambito === 'I' ? 'AMB_CAP_LIQUIDACIONES_INTERIOR' : 'AMB_CAP_LIQUIDACIONES_AMBA_BSAS'; */
    const { emailsSeleccionados } = data;

    if (!emailsSeleccionados || emailsSeleccionados.length === 0) {
      // Agrego el email del prestador logueado si no selecciono ninguno
      emailsSeleccionados.push(data.prestadorLogueado);
    }
    const jsonCapWeb = {
      process: {
        variables: {
          workContext: workContext,
          finalizado: 'false',
          processInfo: {
            id: '0',
            name: 'Pedido Cap',
            description: 'Pedido Cap',
            registradoUsuario: optionProcess.user, //"ext_dibarbon",
            registradoNombre: optionProcess.description, //"CN=Diego Barbonetti,OU=Externos,OU=Groups&Users,OU=-SMG-,DC=swm,DC=com,DC=ar,
            credencial: auth && auth.codPrestador ? auth.codPrestador.toString() : '',
            procesoRelacionadoId: data.nroPedidoReplicar ? data.nroPedidoReplicar.toString() : null, //En este campo debe ir el processId cuando se utilice la funcion de duplicar tramites para que en SGI queden como relacionados un tramite respecto al otro
            atencionRelacionadaId: null,
            detalle: `${data.motivoDetalle}, ${
              domicilio && domicilio.provincia ? domicilio.provincia.descripcion : ''
            }, ${domicilio && domicilio.localidad ? domicilio.localidad.descripcion : ''}, ${
              razonSocial || ''
            }, Trámite Generado desde la Web`,
          },
        },
        credencial: auth && auth.codPrestador ? auth.codPrestador.toString() : '',
        version: '1',
        processName: 'Pedido Cap',
        status: 'Running',
        workContext: workContext,
        currentNodeName: '',
        ambitoGestion: '', // "AMB_CLINICA_PROPIA_ODONTO",
        detalle: `${data.motivoDetalle}, ${
          domicilio && domicilio.provincia ? domicilio.provincia.descripcion : ''
        }, ${domicilio && domicilio.localidad ? domicilio.localidad.descripcion : ''}, ${
          razonSocial || ''
        }, Trámite Generado desde la Web`,
        id: null,
        processId: null,
        key: null,
        start: Date.now(),
      },
      capObject: {
        generico: {
          prestadorId: auth && auth.codPrestador ? auth.codPrestador.toString() : '',
          prestadorTipo: authPrestadorTipo,
          motivo: {
            id: 3,
          },
          etapa: {
            sucursalUsuarioId: 1, // 202,
            estado: {
              id: 1,
            },
            id: null,
          },
          estado: {
            id: 1,
            descripcion: 'Pendiente',
          },
          sucursalId: 1, // 202,
          submotivo: {
            id: 24,
          },
          unidadNegocio: {
            id: 1,
          },
          observacion: '-',
          tomadoPor: null,
          ucid: null,
          ani: null,
          dnis: null,
          registroUsuario: optionProcess.user, // auth.razonSocialPrestador,
          direccion: null,
          detalle: `${data.motivoDetalle}, ${
            domicilio && domicilio.provincia ? domicilio.provincia.descripcion : ''
          }, ${domicilio && domicilio.localidad ? domicilio.localidad.descripcion : ''}, ${
            razonSocial || ''
          }, Trámite Generado desde la Web`,
          submotivoBOAP: {
            id: -1,
          },
        },
        especifico: {
          motivoContacto: {
            id: null, // -1 o null ... 160
          },
          pedido: data.pedido,
        },
        extendedProcess: {
          motivoWeb: parseInt(data.motivo),
          estadoWeb: 1, //1 = Pendiente, 2 = Cerrado
          usuarioWeb: data.prestadorLogueado.email,
          pedidoWeb: data.pedido,
          rudiFiles: archivos,
          emails: emailsSeleccionados,
          info1: data.motivoDetalle,
          mailRedireccion: 0,
          mailFinalizacion: 0,
          expediente: {
            oficina: 1,
            numero: data.nroExpediente,
            comprobante: {
              numero: data.nroComprobante.trim(),
              tipo: data.tipoComprobante,
            },
          },
        },
      },
      id: '3', //Siempre en 3 porque es pedido
      idSubmotive: 24,
      motive: detallePedido,
      workflowId: null,
    };

    return new Promise((resolve, reject) => {
      fetch(`https://mobile${env}.swissmedical.com.ar/api-smg/V1/prestadores/cap/grabar-tramite`, {
        method: 'POST',
        headers: {
          'authorization': 'Bearer ' + token,
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(jsonCapWeb),
      })
        .then((response) => {
          if (response) {
            return response.json();
          } else {
            reject();
          }
        })
        .then((json) => {
          dispatch(responseEnd());

          resolve(json);

          fetch(
            `https://mobile${env}.swissmedical.com.ar/api-smg/V1/prestadores/cap/${
              json.jbpmProcess
            }/${Date.now()}/PostProcess1`,
            {
              method: 'GET',
              headers: {
                'authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
              },
            },
          )
            .then((response) => {
              if (response) {
                return response.json();
              } else {
                reject();
              }
            })
            .then((json2) => {
              dispatch(responseEnd());

              let idPostProcess = json2 && json2[0] ? json2[0].id : '';
              if (idPostProcess !== '') {
                fetch(
                  `https://mobile${env}.swissmedical.com.ar/api-smg/V1/prestadores/cap/${idPostProcess}/${workContext}/PostProcess2`,
                  {
                    method: 'GET',
                    headers: {
                      'authorization': 'Bearer ' + token,
                      'Content-Type': 'application/json',
                      'Accept': 'application/json',
                    },
                  },
                )
                  .then((response) => {
                    if (response) {
                      return response.json();
                    } else {
                      reject();
                    }
                  })
                  .then((json3) => {
                    dispatch(responseEnd());
                    // resolve(json3)
                  })
                  .catch((err) => {
                    dispatch(responseEnd());
                    resolve(err);
                  });
              }
            })
            .catch((err) => {
              dispatch(responseEnd());
              resolve(err);
            });
        })
        .catch((err) => {
          dispatch(responseEnd());
          resolve(err);
        });
    });
  } else {
    dispatch(logoutUser());
  }
};

export const fetchInbox = () => async (dispatch) => {
  dispatch(responseWait());
  const DIAS_PRECARGA = 15;
  const hoy = Dates.get().toFormat('YYYY-MM-DD');
  const inicio = Dates.getWithSubtractDays(DIAS_PRECARGA).toFormat('YYYY-MM-DD');
  let codigoPrestador;
  const auth = Session.getAuth()?.modelEspecifico;

  if (auth) {
    codigoPrestador = auth?.codPrestador;
    const json = {
      prestad: parseInt(codigoPrestador, 10),
      estado: 2,
      areaConsulta: null,
      fechaDesde: inicio + ' 00:00:00',
      fechaHasta: hoy + ' 23:59:59',
    };

    try {
      const { status, data } = await apiManagerRequest.post(
        `${baseApiManagerUrl}/v1/contacto-prestador/consulta-tramites-contacto-prestador`,
        json,
      );

      if (status === 200) {
        let pendientes = [];
        if (data) {
          pendientes = data;
        } else {
          pendientes = [];
        }
        dispatch(cleanDetalleTramite());
        dispatch(loadInbox(pendientes));
      }

      if (status === 401) {
        dispatch(logoutUser);
      }
    } catch (error) {
      dispatch(loadInbox([]));
      dispatch(cleanDetalleTramite());
      dispatch(showMessage('danger', 'Lo sentimos, hubo un error al obtener trámites pendientes'));
    } finally {
      dispatch(responseEnd());
    }
  }
};

export const fetchInboxAction = () => ({
  type: FETCH_INBOX,
});

export const loadInbox = (tramitesPendientes) => ({
  type: LOAD_INBOX,
  pendientes: tramitesPendientes,
});

export const loadTable = (tramites) => ({
  type: LOAD_TABLE,
  tramites: tramites,
});

export const loadDetalleTramite = (detalle, task) => ({
  type: LOAD_DETALLE_TRAMITE,
  detalle: detalle,
  tasks: task,
});

export const cleanDetalleTramite = () => {
  return loadDetalleTramite(null, null);
};

export const quitarTramiteDePendientes = (tramiteId) => ({
  type: REMOVE_TRAMITE_FROM_PENDIENTES,
  tramiteId,
});

export const setArchivosEtapa = (adjuntos, env) => ({
  type: SET_ARCHIVOS_ETAPAS,
  payload: {
    adjuntos: adjuntos,
  },
});

export const setTramiteResponder = (tramite) => ({
  type: SET_TRAMITE_RESPONDER,
  payload: {
    tramite: tramite,
  },
});

export const setActiveTab = (active, tramite) => ({
  type: SET_ACTIVE_TAB,
  payload: {
    active: active,
    selectedTramite: tramite,
  },
});

export const fetchDetalleTramite = (tramiteJbpm, callback) => async (dispatch) => {
  if (tramiteJbpm) {
    dispatch(responseWait());

    try {
      const { status, data } = await apiManagerRequest.get(
        `${baseApiManagerUrl}/v2/proveedores/tramites/${tramiteJbpm}`,
      );

      if (status === 200) {
        dispatch(loadDetalleTramite(data.processDetail, data.taskDetail));
        cargoFromRudi(data.processDetail.tramite, dispatch);
      }

      if (status === 401) {
        dispatch(logoutUser());
      }
    } catch (error) {
      dispatch(
        showMessage('danger', 'Lo sentimos, hubo un error al obtener información del trámite.'),
      );
    } finally {
      dispatch(responseEnd());
    }
  } else {
    dispatch(cleanDetalleTramite());
  }
};

async function cargoFromRudi(tramite, dispatch) {
  // let { env } = await fetch(generateAbsoluteUrl() + '/env').then(res => res.json())
  const options = {
    method: 'GET',
    json: {},
  };
  let archivos = [];
  if (tramite.rudiSGI) {
    const filesSGI = await new Promise((resolve, reject) => {
      (async () => {
        try {
          const { status, data } = await apiManagerRequest.get(
            `${baseApiManagerUrl}/v0/archivos/WCAP/${tramite.rudiSGI.nroTramite}`,
          );

          if (status === 200) {
            resolve(data);
          }
        } catch (error) {
          reject(error);
        }
      })();
    })
      .then((response) => response.imagenesArchivo.items)
      .catch((err) => []);

    archivos = archivos.concat(filesSGI);
  }

  if (tramite.rudiPrestador) {
    const filesPrestador = await new Promise((resolve, reject) => {
      (async () => {
        try {
          const { status, data } = await apiManagerRequest.get(
            `${baseApiManagerUrl}/v0/archivos/WCAP/${tramite.rudiPrestador.nroTramite}`,
          );

          if (status === 200) {
            resolve(data);
          }
        } catch (error) {
          reject(error);
        }
      })();
    })
      .then((response) => response.imagenesArchivo.items)
      .catch((err) => []);

    archivos = archivos.concat(filesPrestador);
  }
  if (env === 'prod') {
    //cambio el prefijo de la url para que tenga url publica
    archivos.forEach((file) => {
      const prefix = 'http://sgi/';
      const finalPrefix = 'https://sgi.swissmedical.com.ar/';
      file.urlPublicacion = file.urlPublicacion.replace(prefix, finalPrefix);
    });
  }
  dispatch(setArchivosEtapa(archivos));
}

export const searchTramites = (inicio, fin, areaConsulta, estado) => async (dispatch) => {
  const auth = Session.getAuth()?.modelEspecifico;
  if (auth) {
    let codigoPrestador = auth?.codPrestador;
    dispatch(responseWait());
    const json = {
      prestad: parseInt(codigoPrestador, 10),
      estado: estado,
      areaConsulta: areaConsulta,
      fechaDesde: inicio + ' 00:00:00',
      fechaHasta: fin + ' 23:59:59',
    };

    if (env === 'prod') env = '';
    try {
      const { status, data } = await apiManagerRequest.post(
        `${baseApiManagerUrl}/v1/contacto-prestador/consulta-tramites-contacto-prestador`,
        json,
      );

      if (status === 200) {
        let pendientes = [];
        if (data) {
          pendientes = data;
        } else {
          pendientes = [];
        }
        dispatch(loadTable(pendientes));
        dispatch(responseEnd());
      }

      if (status === 401) {
        dispatch(logoutUser);
      }
    } catch (error) {
      dispatch(loadTable([]));
      dispatch(responseEnd());
      dispatch(showMessage('danger', 'Lo sentimos, hubo un error al obtener trámites pendientes'));
    }
  }
};

export const saveContacto = (tramite, respuesta, archivos) => async (dispatch) => {
  const auth = Session.getAuth()?.modelEspecifico;
  let token = Session.getAuthenticationToken();
  let codigoPrestador;
  if (auth) {
    codigoPrestador = auth?.codPrestador;
    dispatch(responseWait());
    let WORK_CONTEXT = 'AMB_CONTRATACIONES_ENTRADA';
    if (tramite.tramite.areaConsulta.toUpperCase() === 'CONTRATACIONES') {
    } else if (tramite.tramite.areaConsulta.toUpperCase() === 'AUTORIZACIONES') {
      WORK_CONTEXT = 'AMB_AUTORIZACIONES_ENTRADA';
    } else if (tramite.tramite.areaConsulta.toUpperCase() === 'LIQUIDACIONES') {
      WORK_CONTEXT = 'AMB_LIQUIDACIONES_ENTRADA';
    }

    const transicionarTramite = async (tramite, respuesta, archivosId = null) => {
      const task = tramite.tasks.reduce(function (prev, current) {
        return prev.create > current.create ? prev : current;
      });
      let etapa;
      tramite.tramite.estado = 1;
      if (archivosId) {
        etapa = {
          obsWeb: respuesta,
          usuarioWeb: auth.emailPrestador || auth.email,
          archivos: archivosId,
        };
      } else {
        etapa = {
          obsWeb: respuesta,
          usuarioWeb: auth.emailPrestador || auth.email,
        };
      }

      let transicion = {
        motivo: {
          id: '107',
        },
        estado: {
          id: '1',
        },
        user: {
          id: optionProcess.description,
          username: optionProcess.specificUser,
          name: optionProcess.name,
        },
        medio: {
          id: '8',
          numero: 'Web',
        },
        sucursal: {
          id: '1',
        },
        afiContactado: '1',
        task: {
          id: `${task.id}`,
        },
        process: {
          variables: {
            workContext: WORK_CONTEXT,
            processInfo: {
              id: '0',
              name: 'Contacto Prestador ' + tramite.tramite.areaConsulta,
              description: 'Contacto Prestador ' + tramite.tramite.areaConsulta,
              credencial: tramite.tramite.prestad,
            },
          },
          id: `${tramite.tramite.tramiteJbpm}`,
          version: '1',
          processName: 'Contacto Prestador ' + tramite.tramite.areaConsulta,
          key: tramite.tramite.tramiteId,
          status: 'Running',
          action: 'tramite-recibido',
          credencial: tramite.tramite.prestad,
        },
      };

      if (tramite.tramite.areaConsulta.toUpperCase() === 'CONTRATACIONES') {
        transicion.tramiteCPC = {
          tramite: tramite.tramite,
          credencial: tramite.tramite.prestad,
          prestador_tipo_deno: 'prestador',
          etapa: etapa,
        };
      } else if (tramite.tramite.areaConsulta.toUpperCase() === 'AUTORIZACIONES') {
        transicion.tramiteCPA = {
          tramite: tramite.tramite,
          credencial: tramite.tramite.prestad,
          prestador_tipo_deno: 'prestador',
          etapa: etapa,
        };
      } else if (tramite.tramite.areaConsulta.toUpperCase() === 'LIQUIDACIONES') {
        transicion.tramiteCPL = {
          tramite: tramite.tramite,
          credencial: tramite.tramite.prestad,
          prestador_tipo_deno: 'prestador',
          etapa: etapa,
        };
      }

      try {
        const { status } = await apiManagerRequest.put(
          `${baseApiManagerUrl}/v1/prestadores/cap/transicionar-tramite`,
          transicion,
        );

        if (status === 200) {
          dispatch(quitarTramiteDePendientes(tramite.tramite.tramiteJbpm));
          dispatch(cleanDetalleTramite());
          dispatch(responseEnd());
          dispatch(showMessage('success', 'Su respuesta ha sido enviada.'));
        }

        if (status === 401) {
          dispatch(logoutUser());
        }
      } catch (error) {
        dispatch(responseEnd());
        dispatch(showMessage('danger', 'Lo sentimos, hubo un error al enviar su respuesta'));
      }
    };

    if (tramite.tramite.rudiPrestador) {
      if (!archivos) {
        transicionarTramite(tramite, respuesta);
      } else {
        let promises = archivos.map((archivo) => {
          const body = {
            fileName: archivo.name + '.' + archivo.extension,
            sizeInBytes: archivo.size,
            base64Content: archivo.base64,
          };
          return new Promise((resolve, reject) => {
            (async () => {
              try {
                const { status, data } = await apiManagerRequest.post(
                  `${baseApiManagerUrl}/V1/archivos/WCAP/tramite/${tramite.tramite.rudiPrestador.nroTramite}/guardar`,
                  body,
                );

                if (status === 200) {
                  resolve(data);
                }
              } catch (error) {
                reject(error);
              }
            })();
          });
        });
        Promise.all(promises)
          .then((values) => {
            let archivosId = values.map((f) => f.pk.id);
            transicionarTramite(tramite, respuesta, archivosId);
          })
          .catch((error) => {
            dispatch(responseEnd());
            if (error && error.statusCode && error.statusCode === 401) {
              dispatch(logoutUser());
            } else {
              dispatch(showMessage('danger', 'Lo sentimos, hubo un error al enviar su respuesta'));
            }
          });
      }
    } else {
      //NO RUDI
      if (!archivos || archivos.length == 0) {
        transicionarTramite(tramite, respuesta);
      } else {
        let items = archivos.map((archivo) => {
          return {
            fileName: archivo.name + '.' + archivo.extension,
            sizeInBytes: archivo.size,
            base64Content: archivo.base64,
          };
        });

        //CREAR RUDI
        let json = {
          pk: {
            tipoTramite: 'WCAP',
          },
          origen: 'Web de Prestadores:',
          observaciones: 'alta de tramite por adjuntos del prestador',
          imagenesArchivo: {
            items: items,
          },
        };

        let p1 = new Promise((resolve, reject) => {
          (async () => {
            try {
              const { status, data } = await apiManagerRequest.post(
                `${baseApiManagerUrl}/V1/archivos/rudi/guardar`,
                json,
              );

              if (status === 200) {
                resolve(data);
              }
            } catch (error) {
              reject(error);
            }
          })();
        });

        p1.catch((err) => {
          dispatch(responseEnd());
          dispatch(showMessage('danger', 'Lo sentimos, hubo un error al enviar su respuesta'));
        });
        p1.then(async (response) => {
          tramite.tramite.rudiPrestador = {
            tipoTramite: 'WCAP',
            nroTramite: response.pk.nroTramite,
          };
          let archivosId = response.imagenesArchivo.items.map((f) => f.pk.id);
          transicionarTramite(tramite, respuesta, archivosId);
        });
      }
    }
  } else {
    dispatch(logoutUser());
  }
};

export const buscarTramiteAutorizacion =
  (data, errorThrow = false) =>
  async (dispatch) => {
    dispatch(responseWait());
    const auth = Session.getAuth()?.modelEspecifico;
    let codigoPrestador;
    if (auth) {
      codigoPrestador = auth?.codPrestador;
      let token = Session.getAuthenticationToken();
      const DIAS_LIMITE_PEDIDO = CAPWEB_AUTORIZACIONES_TIEMPO_MAX;
      const hoy = Dates.getWithAddDays(1).toFormat('YYYY-MM-DD');
      const inicio = Dates.getWithSubtractDays(DIAS_LIMITE_PEDIDO).toFormat('YYYY-MM-DD');
      data.motivoId = 9;
      data.fechaDesde = inicio;
      data.fechaHasta = hoy;
      data.prestad = codigoPrestador;
      data.estado = 1;
      if (env === 'prod') env = '';
      if (data.nroTrmAutorizacion) {
        try {
          const { data: response } = await apiManagerRequest.get(
            `${baseApiManagerUrl}/V1/process/tramite/${data.nroTrmAutorizacion}`,
          );

          const { data: rta } = await apiManagerRequest.get(
            `${baseApiManagerUrl}/v2/busqueda-autorizaciones?prestad=${codigoPrestador}&workflowId=${response.key}`,
          );

          if (rta && rta.length > 0 && rta[0].auto) {
            const json = {
              nroAutorizacion: rta[0].auto,
              prestad: codigoPrestador,
              estado: '',
              motivoId: '9',
              fechaDesde: inicio,
              fechaHasta: hoy,
            };

            const respRequestProcedure = await apiManagerRequest.post(
              `${baseApiManagerUrl}/V1/prestadores/cap/ConsultaTramites`,
              json,
            );

            rta[0].tramitesCapAuto = respRequestProcedure.data;
            return rta;
          }
        } catch (error) {
          if (errorThrow) {
            throw error;
          }

          return [];
        } finally {
          dispatch(responseEnd());
        }
      } else {
        //let baseurl = `http://sgi${env}/ws.cap/rest-api/sgi-cap/search-auto-prestad?prestad=${codigoPrestador}`;
        let baseurl = `/v2/busqueda-autorizaciones?prestad=${codigoPrestador}`;
        if (data.contraAfi) {
          baseurl = baseurl + `&contra=${data.contraAfi}`;
        }
        if (data.inteAfi) {
          baseurl = baseurl + `&inte=${data.inteAfi}`;
        }
        if (data.nroAutorizacion) {
          baseurl = baseurl + `&nroAuto=${data.nroAutorizacion}`;
        }
        if (data.workflowId) {
          baseurl = baseurl + `&workflowId=${data.workflowId}`;
        }
        //2498911 - 2553566
        try {
          const { data } = await apiManagerRequest.get(`${baseApiManagerUrl}${baseurl}`);
          let rta = data;
          if (rta.length > 0 && rta[0].auto) {
            const json = {
              nroAutorizacion: rta[0].auto,
              prestad: codigoPrestador,
              estado: '',
              motivoId: '9',
              fechaDesde: inicio,
              fechaHasta: hoy,
            };
            const requestProcedure = await apiManagerRequest.post(
              `${baseApiManagerUrl}/V1/prestadores/cap/ConsultaTramites`,
              json,
            );
            rta[0].tramitesCapAuto = requestProcedure.data;
            return rta;
          }
        } catch (error) {
          if (errorThrow) {
            throw error;
          }

          return [];
        } finally {
          dispatch(responseEnd());
        }
      }
    } else {
      dispatch(responseEnd());
      dispatch(logoutUser());
    }
  };

export const grabarPedidoAutorizacion = (data) => async (dispatch) => {
  dispatch(responseWait());
  const auth = Session.getAuth()?.modelEspecifico;
  const razonSocial = Session.getAuth()?.apeRazonSocial;
  const authPrestadorTipo = Session.getAuth()?.tipoPrestador?.id;
  const domicilio = Session.getAuth()?.domicilio;

  let token = Session.getAuthenticationToken();
  let codigoPrestador;
  if (auth) {
    codigoPrestador = auth?.codPrestador;
    if (env === 'prod') env = '';

    // ARCHIVOS ADJUNTOS
    const archivos = [];
    const detallePedido = 'Pedido Cap Autorizaciones';
    const workContext = 'AMB_CAP_AUTORIZACIONES';
    const ambitoAutorizacion = {
      'Prácticas y Cirugías': 'AMB_CAP_AUTORIZACIONES',
      'Cirugía con materiales y prótesis': 'AMB_CAP_PROTESIS',
      'Medicación con o sin Prestación': 'AMB_CAP_FARMACIA_AUT',
      'Práctica o Cirugía con material y medicación': 'AMB_CAP_PROTESIS',
    };
    const submotivoAutorizacion = {
      'Prácticas y Cirugías': 9,
      'Cirugía con materiales y prótesis': 18,
      'Medicación con o sin Prestación': 8,
      'Práctica o Cirugía con material y medicación': 18,
    };

    const ambitoCorrecto = ambitoAutorizacion[data.motivoDetalle];
    const idSubmotivo = submotivoAutorizacion[data.motivoDetalle];
    const { emailsSeleccionados } = data;

    if (!emailsSeleccionados || emailsSeleccionados.length === 0) {
      // Agrego el email del prestador logueado si no selecciono ninguno
      emailsSeleccionados.push(data.prestadorLogueado);
    }

    const jsonCapWeb = {
      process: {
        variables: {
          workContext: workContext,
          finalizado: 'false',
          processInfo: {
            id: '0',
            name: 'Pedido Cap',
            description: 'Pedido Cap',
            registradoUsuario: optionProcess.user, //"ext_dibarbon",
            registradoNombre: optionProcess.description, //"CN=Diego Barbonetti,OU=Externos,OU=Groups&Users,OU=-SMG-,DC=swm,DC=com,DC=ar,
            credencial: codigoPrestador + '',
            procesoRelacionadoId: null,
            atencionRelacionadaId: null,
            detalle: `${data.motivoDetalle}, ${
              domicilio && domicilio.provincia ? domicilio.provincia.descripcion : ''
            }, ${domicilio && domicilio.localidad ? domicilio.localidad.descripcion : ''}, ${
              razonSocial || ''
            }, Trámite Generado desde la Web`,
          },
        },
        credencial: codigoPrestador + '',
        version: '1',
        processName: 'Pedido Cap',
        status: 'Running',
        workContext: workContext,
        currentNodeName: '',
        ambitoGestion: 'AMB_CLINICA_PROPIA_ODONTO', // "AMB_CLINICA_PROPIA_ODONTO",
        detalle: `${data.motivoDetalle}, ${
          domicilio && domicilio.provincia ? domicilio.provincia.descripcion : ''
        }, ${domicilio && domicilio.localidad ? domicilio.localidad.descripcion : ''}, ${
          razonSocial || ''
        }, Trámite Generado desde la Web`,
        id: null,
        processId: null,
        key: null,
        start: Date.now(),
      },
      capObject: {
        generico: {
          prestadorId: codigoPrestador + '',
          prestadorTipo: authPrestadorTipo,
          motivo: {
            id: 3,
          },
          etapa: {
            sucursalUsuarioId: 1, // 202,
            estado: {
              id: 1,
            },
            id: null,
          },
          estado: {
            id: 1,
            descripcion: 'Pendiente',
          },
          sucursalId: 1, // 202,
          submotivo: {
            id: idSubmotivo,
          },
          unidadNegocio: {
            id: 1,
          },
          observacion: '-',
          tomadoPor: null,
          ucid: null,
          ani: null,
          dnis: null,
          registroUsuario: optionProcess.user, // auth.razonSocialPrestador,
          direccion: null,
          detalle: `${data.motivoDetalle}, ${
            domicilio && domicilio.provincia ? domicilio.provincia.descripcion : ''
          }, ${domicilio && domicilio.localidad ? domicilio.localidad.descripcion : ''}, ${
            razonSocial || ''
          }, Trámite Generado desde la Web`,
          submotivoBOAP: {
            id: -1,
          },
        },
        especifico: {
          motivoContacto: {
            id: null, // -1 o null ... 160
          },
          pedido: data.pedido,
        },
        extendedProcess: {
          motivoWeb: parseInt(data.motivo),
          estadoWeb: 1, //1 = Pendiente, 2 = Cerrado
          usuarioWeb: data.prestadorLogueado.email,
          pedidoWeb: data.pedido,
          nroAutorizacion: data.selectedTramite ? data.selectedTramite.auto : null,
          nroTrmAutorizacion: data.selectedTramite ? data.selectedTramite.nroTramite : null,
          contraAfi: data.selectedTramite
            ? data.selectedTramite.contra
            : data.nroAfiliado?.split?.(' ')?.[0] ?? '',
          inteAfi: data.selectedTramite
            ? data.selectedTramite.inte
            : data.nroAfiliado?.split?.(' ')?.[2] ?? '',
          nombreApeAfi: data.selectedTramite
            ? data.selectedTramite.nombre + ' ' + data.selectedTramite.ape
            : data.nombreApellido,
          fechaAutorizacion: data.selectedTramite
            ? Dates.get(data.selectedTramite.fecha).toFormat('DD/MM/YYYY')
            : null,
          pedidoWeb: data.pedido,
          mailRedireccion: 0,
          mailFinalizacion: 0,
          rudiFiles: archivos,
          emails: emailsSeleccionados,
          info1: data.motivoDetalle,
        },
      },
      id: '3', //Siempre en 3 porque es pedido
      idSubmotive: idSubmotivo,
      motive: detallePedido, //Idem anterior
      workflowId: null,
    };

    return new Promise((resolve, reject) => {
      fetch(
        `https://mobile${env}.swissmedical.com.ar/pre/api-smg/v1/prestadores/cap/alta-tramite`,
        {
          method: 'POST',
          headers: {
            'authorization': 'Bearer ' + token,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify(jsonCapWeb),
        },
      )
        .then((response) => {
          if (response) {
            return response.json();
          } else {
            reject();
          }
        })
        .then((json) => {
          resolve(json);
          fetch(
            `https://mobile${env}.swissmedical.com.ar/api-smg/V1/prestadores/cap/${
              json.jbpmProcess
            }/${Date.now()}/PostProcess1`,
            {
              method: 'GET',
              headers: {
                'authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
              },
            },
          )
            .then((response) => {
              if (response) {
                return response.json();
              } else {
                reject();
              }
            })
            .then((json2) => {
              dispatch(responseEnd());

              let idPostProcess = json2 && json2[0] ? json2[0].id : '';
              if (idPostProcess !== '') {
                fetch(
                  `https://mobile${env}.swissmedical.com.ar/api-smg/V1/prestadores/cap/${idPostProcess}/${ambitoCorrecto}/PostProcess2`,
                  {
                    method: 'GET',
                    headers: {
                      'authorization': 'Bearer ' + token,
                      'Content-Type': 'application/json',
                      'Accept': 'application/json',
                    },
                  },
                )
                  .then((response) => {
                    if (response) {
                      return response.json();
                    } else {
                      reject();
                    }
                  })
                  .then((json3) => {
                    dispatch(responseEnd());
                  })
                  .catch((err) => {
                    dispatch(responseEnd());
                    resolve(err);
                  });
              }
            });
        })
        .catch((err) => {
          dispatch(responseEnd());
          resolve(err);
        });
    });
  } else {
    dispatch(logoutUser());
  }
};

export const openTramiteAutorizacion = (active, tramite) => async (dispatch) => {
  if (tramite.auto) {
    const data = {
      nroAutorizacion: tramite.auto,
    };
    let p = await dispatch(buscarTramiteAutorizacion(data));
    if (p && p.length > 0) {
      await dispatch(selectTramiteAutorizacion(p[0]));
    } else {
      dispatch(selectTramiteAutorizacion(null));
    }
  } else {
    const auth = Session.getAuth()?.modelEspecifico;
    let token;

    if (auth) {
      token = Session.getAuthenticationToken();
    }

    const request = {
      token,
      codigoPrestador: auth.id,
      contra: tramite.contra.trim(),
      inte: tramite.inte.trim(),
    };

    await dispatch(validarAfiliado(request.contra, request.inte))()
      .then(async (a) => {
        if (a) {
          dispatch(validarAfiliadoSucess(a));
          await dispatch(selectAfiliadoAutorizacion(a));
        } else {
          dispatch(validarAfiliadoError(''));
        }
        dispatch(responseEnd());
      })
      .catch((e) => {
        dispatch(responseEnd());
      });
  }
};

export const selectTramiteAutorizacion = (tramite) => ({
  type: SELECT_TRAMITE_AUTORIZACION,
  tramite: tramite,
  active: 'altaDeTramites',
});

export const selectAfiliadoAutorizacion = (afiliado) => ({
  type: SELECT_AFILIADO_AUTORIZACION,
  afiliado: afiliado,
  active: 'altaDeTramites',
});

export const resetState = () => {
  return {
    type: RESET_CAP_WEB_STATE,
  };
};
